import { ANIMATION_IDENTIFIERS, DrawAnimationMechanicConfig } from '@Animation/types'
import { PLUS_3_CONFIG } from '../add-on-extra-draw/plus-3/config'
import { CyberSnakesNumberSelector } from './number-selector'
import { CyberSnakesNumber } from './number'
import { preLoadAssets } from './preload-assets'
import { CyberSnakesBackground } from './background'
import { CYBER_SNAKES_MULTIPLIER_CONFIG } from '../add-on-multiplier/cyber-snakes/config'
import { CyberSnakeTexturePreloader } from './texture-loader'
import { CYBER_SNAKES_AUDIO_KEYS } from './constants'

export const CyberSnakesConfig: DrawAnimationMechanicConfig = {
  appSettings: {
    backgroundBaseColor: '#00222FFF',
    backgroundGlowColor: '#00B7FFFF',
    backgroundUrl: '/animations/cyber-snakes/background.png',
  },
  numberSelector: CyberSnakesNumberSelector,
  background: CyberSnakesBackground,
  foreground: null,
  kenoNumber: CyberSnakesNumber,
  multiplierAnimationConfig: CYBER_SNAKES_MULTIPLIER_CONFIG,
  assetPreloader: preLoadAssets,
  extraDrawAnimationConfig: PLUS_3_CONFIG(ANIMATION_IDENTIFIERS.CYBER_SNAKES),
  textureLoader: CyberSnakeTexturePreloader,
  audioKeys: CYBER_SNAKES_AUDIO_KEYS
}
